import React from "react";
import "../../../../style/components/whatsAppPreview.css";
import { bg_whatsapp, whatsapp_brand, sms_preview } from "../../../../images/WhatsAppImages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FaWeight } from "react-icons/fa";

function SMSPreview(props) {
  const { dynamicData, campaignType, previewData,smsContent, senderId } = props;
  // console.log(previewData)
  return (
    <div className="whatsapp">
      {previewData && (
        <>
          <ul>
            <li>
              {" "}
              <strong> Template name: </strong> {previewData.template_name}{" "}
            </li>
            <li>
              {" "}
              <strong> Sender ID: </strong> {senderId}{" "}
            </li>
            <li>
              {" "}
              <strong> Entity ID : </strong> {previewData.entity_id}{" "}
            </li>
            <li>
              {" "}
              <strong> Template ID : </strong> {previewData.template_id}{" "}
            </li>
          </ul>
          <div
            style={{ backgroundImage: `url(${sms_preview})` }}
            className="whatsapp-review whatsapp-bg"
          >
            <div>
              <div className="text-section">
                <div className="sms-app-header" style={{ color:"#000000"}}>
                  <div className="">
                    {" "}
                    {/* <img src={whatsapp_brand} /> */}
                    <FontAwesomeIcon icon={faUser}/>
                    {" "}
                  </div>
                  <div className="">
                    {" "}
                    <p style={{color: "black", marginTop: "10px"}}>{senderId}</p>{" "}
                  </div>
                </div>
                <div className="body-message" style={{border: "2px solid black", borderRadius :"10px"}} >
                  <p style={{color: "black"}}> {previewData.template_msg}</p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SMSPreview;
